import { RentalMaterialization } from "@/models/rental-materialization.model.ts"
import type { IRentalIntakeMaterialization } from "@/interfaces/api/rental-intake-materialization.interface.ts"
import { RentalIntake } from "@/models/rental-intake.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { IncomingInvoiceRentalIntakeMaterialization } from "@/models/incoming-invoice-rental-intake-materialization.model.ts"

export class RentalIntakeMaterialization
  extends RentalMaterialization
  implements IRentalIntakeMaterialization
{
  rentalMutation: RentalIntake
  incomingInvoiceRentalIntakeMaterializations: IncomingInvoiceRentalIntakeMaterialization[]

  invoiceReference?: string

  // Annotated fields
  instructionId: string
  rentalIntakeItemId: string
  rentalIntakeItemName: string
  rentalIntakeItemSupplierId: string
  rentalIntakeItemSupplierName: string
  projectId: string

  constructor(rentalIntakeMaterialization: IRentalIntakeMaterialization, managed = false) {
    super(rentalIntakeMaterialization)

    this.rentalMutation = ModelFactory.childModel(
      RentalIntake,
      rentalIntakeMaterialization.rentalMutation,
      managed
    )
    this.incomingInvoiceRentalIntakeMaterializations = ModelFactory.childModels(
      IncomingInvoiceRentalIntakeMaterialization,
      rentalIntakeMaterialization.incomingInvoiceRentalIntakeMaterializations,
      managed
    )
    this.invoiceReference = rentalIntakeMaterialization.invoiceReference

    this.instructionId = rentalIntakeMaterialization.instructionId
    this.rentalIntakeItemId = rentalIntakeMaterialization.rentalIntakeItemId
    this.rentalIntakeItemName = rentalIntakeMaterialization.rentalIntakeItemName
    this.rentalIntakeItemSupplierId = rentalIntakeMaterialization.rentalIntakeItemSupplierId
    this.rentalIntakeItemSupplierName = rentalIntakeMaterialization.rentalIntakeItemSupplierName
    this.projectId = rentalIntakeMaterialization.projectId
  }

  public getMatchedQuantity() {
    return this.incomingInvoiceRentalIntakeMaterializations.reduce(
      (sum, rim) => sum + Number(rim.quantity),
      0
    )
  }

  public getOutstandingQuantity() {
    return this.getUnitDays() - this.getMatchedQuantity()
  }

  public isOutstanding() {
    return (
      this.getOutstandingQuantity() > 0 &&
      // Consider invoices matched using the legacy mechanism (this.invoiceReference) to not be outstanding.
      !this.invoiceReference
    )
  }
}
